/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lesson_Custom_PriceInputs */

const en_lesson_custom_price = /** @type {(inputs: Lesson_Custom_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Custom price`)
};

const he_lesson_custom_price = /** @type {(inputs: Lesson_Custom_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מחיר מותאם`)
};

/**
* | output |
* | --- |
* | "Custom price" |
*
* @param {Lesson_Custom_PriceInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const lesson_custom_price = /** @type {((inputs?: Lesson_Custom_PriceInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lesson_Custom_PriceInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_lesson_custom_price(inputs)
	return he_lesson_custom_price(inputs)
});